import React from 'react';
import { SubscriptionPlanDetailsUiModuleBody } from '../../../../../API';
import Localized from '../../../../shared/Localized';
import UIModuleListItem, { IBaseUIModuleListItemProps } from '../../UIModuleListItem';
import { subscriptionPlanDetailsListItemTestIds } from '../../../../shared/TestsIds';

export type SubscriptionPlanDetailsListItemProps = IBaseUIModuleListItemProps<SubscriptionPlanDetailsUiModuleBody>;

export function SubscriptionPlanDetailsListItem({
  uiModule,
  ...props
}: SubscriptionPlanDetailsListItemProps): JSX.Element {
  return (
    <>
      <UIModuleListItem
        uiModule={uiModule}
        topLineTitle={<Localized prop={uiModule.title} data-testid={subscriptionPlanDetailsListItemTestIds.title} />}
        {...props}
      />
    </>
  );
}
